import {
  AppShell,
  BrandMark,
  type NavItem,
  SidebarVersion,
  UserMenu,
} from '@skylabs-digital/backoffice-kit';
import { routerNavItems } from '@skylabs-digital/backoffice-kit/router';
import { useAuthActions, useAuthState } from '@skylabs-digital/react-identity-access';
import {
  Activity,
  Copy,
  Files,
  FolderOpen,
  HardDrive,
  History,
  LayoutDashboard,
  Webhook,
} from 'lucide-react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useVersion } from '../hooks/useVersion';

/**
 * Una superficie de plataforma: todo el que entró es `(platform, admin)`, así
 * que los items no se filtran por rol.
 */
const NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    to: '/',
    icon: <LayoutDashboard className="h-5 w-5" />,
    section: 'Overview',
  },
  {
    label: 'Storage',
    to: '/storage',
    icon: <HardDrive className="h-5 w-5" />,
    section: 'Overview',
  },
  { label: 'Apps', to: '/apps', icon: <FolderOpen className="h-5 w-5" />, section: 'Files' },
  { label: 'Files', to: '/files', icon: <Files className="h-5 w-5" />, section: 'Files' },
  { label: 'Duplicates', to: '/duplicates', icon: <Copy className="h-5 w-5" />, section: 'Files' },
  {
    label: 'Processing',
    to: '/processing',
    icon: <Activity className="h-5 w-5" />,
    section: 'Files',
  },
  { label: 'Webhooks', to: '/webhooks', icon: <Webhook className="h-5 w-5" />, section: 'Events' },
  { label: 'Activity', to: '/activity', icon: <History className="h-5 w-5" />, section: 'Events' },
];

export function AppLayout() {
  const { user, context } = useAuthState();
  const { logout } = useAuthActions();
  const navigate = useNavigate();
  const version = useVersion();

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate('/login', { replace: true });
    }
  };

  return (
    <AppShell
      brand={<BrandMark initials="f" title="fisto" subtitle="Backoffice" />}
      navItems={routerNavItems(NAV_ITEMS)}
      headerRight={
        <UserMenu user={user ?? undefined} subtitle={context?.role} onSignOut={handleLogout} />
      }
      sidebarFooter={<SidebarVersion name="fisto" version={version} />}
    >
      <Outlet />
    </AppShell>
  );
}
